module.exports = __webpack_public_path__ + "3cb8cc81a256c9cd7f555500e1bb28da.MP3";